namespace AgerLMS.LMS {
    export interface LmsDocumentRow {
        Id?: number;
        DocumentName?: string;
        DocumentType?: LessonFileTypes;
        DocumentEntityType?: EntityTypes;
        EntityId?: number;
        OnlineViewer?: boolean;
        Description?: string;
        DisplayOrder?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace LmsDocumentRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const localTextPrefix = 'LMS.LmsDocument';
        export const deletePermission = 'LMS';
        export const insertPermission = 'LMS';
        export const readPermission = 'LMS';
        export const updatePermission = 'LMS';

        export declare const enum Fields {
            Id = "Id",
            DocumentName = "DocumentName",
            DocumentType = "DocumentType",
            DocumentEntityType = "DocumentEntityType",
            EntityId = "EntityId",
            OnlineViewer = "OnlineViewer",
            Description = "Description",
            DisplayOrder = "DisplayOrder",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
